import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=28e018cc&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"
import style0 from "./Show.vue?vue&type=style&index=0&id=28e018cc&prod&lang=css"
import style1 from "./Show.vue?vue&type=style&index=1&id=28e018cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e018cc",
  null
  
)

export default component.exports